import { ROUTE_LAYOUT_TYPE } from '../constants';
import {
  FULL_PAGE_STATUS_CODE,
  ONLY_COMPONENT_STATUS_CODE,
  WITH_GNB_STATUS_CODE,
} from '../constants/error';

import type { StatusCode } from '@kc-console/core';
import type { ServiceMetaRoute } from '../constants';

export const getLayoutVisibleByStatusCode = (statusCode: StatusCode) => {
  if (FULL_PAGE_STATUS_CODE.includes(statusCode)) {
    return { gnb: false, lnb: false };
  } else if (WITH_GNB_STATUS_CODE.includes(statusCode)) {
    return { gnb: true, lnb: false };
  } else if (ONLY_COMPONENT_STATUS_CODE.includes(statusCode)) {
    return { gnb: true, lnb: true };
  } else {
    return;
  }
};

export const getLayoutVisibleByRoute = (route: ServiceMetaRoute | null) => {
  if (!route) return;

  return {
    lnb: route.layoutType === ROUTE_LAYOUT_TYPE.CONTENTS,
    gnb: route.layoutType !== ROUTE_LAYOUT_TYPE.FULL,
  };
};
